import { FlexComponent } from "typings/flexFramework/FlexComponent";
import { Column } from "components/flexComponents/MultiColumnContainer/model/Column";

/**
 * Concrete implementation of a Column
 */
export class OneColumn implements Column {
  public width: string;
  public modules: FlexComponent[];

  public constructor(modules: FlexComponent[], width?: string | null) {
    this.modules = modules;
    this.width = width || "100";
  }

  public getColumnsToRender(): Column[] {
    return [this as Column];
  }
}
